import styled from '@emotion/styled';
import React from 'react';

type TCenteredContentProps = {style?: React.CSSProperties | undefined};
export const CenteredContent = styled.div<TCenteredContentProps>({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
});
